export const httpResponseStatusCodes = {
  accepted: 202,
  badRequest: 400,
  created: 201,
  internalServerError: 500,
  notAllowed: 405,
  notAuthorized: 401,
  notFound: 404,
  notImplemented: 501,
  ok: 200,
  okNoContent: 204,
  temporaryRedirect: 307,
} as const;
